/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type SimulateAuthorizationRequestOptsTransactionType = typeof SimulateAuthorizationRequestOptsTransactionType[keyof typeof SimulateAuthorizationRequestOptsTransactionType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SimulateAuthorizationRequestOptsTransactionType = {
  REFUND: 'REFUND',
  PURCHASE: 'PURCHASE',
  ATM: 'ATM',
  REPAYMENT: 'REPAYMENT',
} as const;
